import PropTypes from 'prop-types'
import {useDisclosure} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'
import VerticalStepper from '~/react/components/VerticalStepper'
import {useRails} from '~/react/contexts/rails'
import {useStepperData} from './useStepperData'
import {useTermsAcceptance} from './useTermsAcceptance'
import TermsAndConditionsModal from '../TermsAndConditionsModal'

export const OnboardingStepper = ({stepperData, refresh}) => {
  const {t} = useTranslation('points')
  const {isOpen, onOpen: openTermsModal, onClose} = useDisclosure()
  const {currentSupplier} = useRails()
  const {handleAcceptTerms, isSubmitting} = useTermsAcceptance(onClose, refresh)
  const {completed, onboardingSteps, currentStep} = useStepperData({
    ...stepperData,
    openTermsModal,
  })

  const handleCancel = () => {
    onClose()
  }

  return (
    <>
      <VerticalStepper
        className="fs-unmask"
        title={t('dashboardScreen.onboardingStepper.title')}
        subtitle={t('dashboardScreen.onboardingStepper.subtitle', {
          context: completed ? 'completed' : null,
        })}
        steps={onboardingSteps}
        currentStep={currentStep}
      />
      <TermsAndConditionsModal
        isOpen={isOpen}
        supplierId={currentSupplier?.id}
        onAccept={handleAcceptTerms}
        onCancel={handleCancel}
        isSubmitting={isSubmitting}
      />
    </>
  )
}

OnboardingStepper.propTypes = {
  stepperData: PropTypes.shape({
    kycVerified: PropTypes.bool.isRequired,
    kycStatus: PropTypes.oneOf(['verified', 'pending', 'rejected']),
    acceptedTermsAndConditions: PropTypes.bool.isRequired,
  }).isRequired,
  refresh: PropTypes.func.isRequired,
}
